import React from 'react';
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { normalizeLang } from "../../utils/localeDataLoader";
import { getBasePathByKeyName } from "../../utils/navMenuCache";

function RootRedirect() {
  const { i18n } = useTranslation();
  const lang = normalizeLang(i18n.language);
  // Dùng slug động từ cache nếu có, nếu chưa thì dùng mặc định
  const homeSlug = getBasePathByKeyName('menu.home', lang) || (lang === 'vi' ? 'trang-chu' : 'home');
  return <Navigate to={`/${homeSlug}`} replace />;
}

export default RootRedirect;
